import ReleaseNotesTab from "../components/organisms/ReleaseNotesTab";

const ReleaseNotesPage = () => {
  return <ReleaseNotesTab />;
};

export default ReleaseNotesPage;
